<template>
  <div>
    <h2 class="project-subtitle">{{ Translator('soprasolar.claim_request.resume.subtitle') }}</h2>
    <p v-if="datas.step0.documentReference">
      {{ Translator('soprasolar.claim_request.step0.form.document_reference.label') }} :
      <strong>{{ Translator('soprasolar.claim_request.step0.form.document_reference.' + datas.step0.documentReference) }}</strong>
    </p>
    <p v-if="datas.step0.documentNumber">
      {{ Translator('soprasolar.claim_request.step0.form.document_number') }} :
      <strong>{{ datas.step0.documentNumber }}</strong>
    </p>
    <p v-if="datas.step0.receiptDate">
      {{ Translator('soprasolar.claim_request.step0.form.receipt_date') }} :
      <strong>{{ datas.step0.receiptDate }}</strong>
    </p>
    <p v-if="datas.step0.receiptLocation">
      {{ Translator('soprasolar.claim_request.step0.form.receipt_location') }} :
      <strong>{{ datas.step0.receiptLocation }}</strong>
    </p>

    <!-- STEP1 -->
    <p v-if="datas.step1.details">
      {{ Translator('soprasolar.claim_request.step1.form.details') }} :<br>
      <strong v-html="datas.step1.details"></strong>
    </p>

    <template v-if="datas.step1.products && datas.step1.products.length > 0">
      <h2 class="collection-subtitle">{{ Translator('soprasolar.claim_request.step1.form.products') }}</h2>
      <ul v-for="product, index in datas.step1.products" :key="index" style="margin-left: 20px;">
        <li>
            <p>
              <strong>
                {{ product.quantity }} x {{ product.name }}
              </strong>
            <i>( {{ product.reference }} )</i>
          </p>
          <div style="margin-left: 20px;" v-if="product.isPhotovoltaic">
            <p><strong>{{ Translator('soprasolar.claim_request.step1.form.product.is_photovoltaic_label') }}</strong></p>
            <ul style="margin-left: 20px;">
              <li v-for="reference in product.references" :key="reference">{{ reference }}</li>
            </ul>
          </div>
        </li>
      </ul>
      <br>
    </template>

    <p v-if="datas.step1.solutions">
      {{ Translator('soprasolar.claim_request.step1.form.solutions') }} :<br>
      <strong v-html="datas.step1.solutions"></strong>
    </p>

    <template v-if="datas.step1.files && datas.step1.files.length > 0">
      <h2 class="collection-subtitle">{{ Translator('soprasolar.claim_request.step1.form.files') }}</h2>
      <div v-for="file in datas.step1.files" :key="file.id">
        <p class="file-element" v-if="file">
          <strong>{{ file.name }}</strong>
          <a :href="'/api/claim-requests/' + tokenAdmin + '/document/' + file.reference" download class="button-download" v-if="isAdmin" target="_blank" rel="noopener noreferrer">
            <i class="ic ic-download"></i>
          </a>
        </p>
      </div>
      <p style="margin-top: 15px;">
        <a :href="'/api/claim-requests/' + tokenAdmin + '/documents'" download class="button-download-all" v-if="isAdmin" target="_blank" rel="noopener noreferrer">
          <i class="ic ic-download"></i>
          {{ Translator('soprasolar.project.resume.download_all') }}
        </a>
      </p>
    </template>

    <!-- STEP2 -->
    <p v-if="datas.step2.comments">
      {{ Translator('soprasolar.claim_request.step2.form.comments') }} :<br>
      <strong v-html="datas.step2.comments"></strong>
    </p>
    <button class="button-print" v-if="isAdmin && currentStep === 'finished'" @click="onPrint">
      <i class="ic ic-print"></i>
      {{ Translator('soprasolar.claim_request.resume.print') }}
    </button>
  </div>
</template>
<style scoped lang="scss">
@import "~@/soprasolar-claim/assets/styles/import";
.file-element {
  display: flex;
  align-items: center;
  gap: rem(10);
}
.button-download {
  @include resetBtn;
  width: rem(30);
  height: rem(30);
  display: flex;
  justify-content: center;
  align-items: center;
  color: $color-main;
  .ic {
    font-size: rem(22);
  }
}
p {
  strong {
    word-break: break-word;
    white-space: break-spaces;
    display: block;
    width: 100%;
  }
  & + p {
    margin-top: rem(20);
  }
}
.collection-subtitle {
  @include title(4);
  margin-top: rem(30);
  font-weight: normal;
  color: $color-second;
}
.button-download-all, .button-print {
  @include cta;
  .ic {
    margin-right: rem(10);
  }
  &:hover, &:focus {
    .ic {
      transform: none;
    }
  }
}
.button-print {
  margin-top: rem(15);
}
</style>
<script>
import AppControlService from '@/soprasolar-claim/services/AppControl';

export default {
  name: 'resume',
  components: {},
  data () {
    return {
      token: AppControlService.token,
      tokenAdmin: AppControlService.tokenAdmin,
      datas: AppControlService.datas,
      currentStep: AppControlService.currentStep,
    }
  },

  computed: {
    isAdmin: () => {
      return AppControlService.isAdmin;
    }
  },

  created() {
    AppControlService.on('datas', this._onUpdateDatas);
  },

  beforeDestroy() {
    AppControlService.off('datas', this._onUpdateDatas);
  },

  mounted() {},

  methods: {
    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },

    _onUpdateDatas(datas) {
      this.datas = datas;
    },

    onPrint() {
      const pageTitle = document.title;
      document.title = `N°${AppControlService.id} - ${AppControlService.datas.step1.company} - ${AppControlService.datas.step2.projectName}`;
      window.print();
      document.title = pageTitle;
    }
  }
};
</script>
